import React, { useRef, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * AdminModal - Modal dialog for administrative functions
 * NOTE: This component is not currently used. Admin UI is loaded via AdminApp.jsx
 * @param {boolean} open - Whether the modal is open
 * @param {Function} onClose - Handler for closing the modal
 */
export default function AdminModal({ open, onClose }) {
  const contentRef = useRef(null);

  // Scroll to top when modal opens
  useEffect(() => {
    if (open && contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          minHeight: '60vh',
          maxHeight: '90vh'
        }
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Administration
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers ref={contentRef}>
        <Typography>Admin features not configured in modal mode</Typography>
      </DialogContent>
    </Dialog>
  );
}
